import { z } from 'zod';

export enum FlowDecorationType {
  StickyNote = 'StickyNote',
  GroupNode = 'GroupNode',
}

export const BaseFlowDecorationSchema = z.object({
  id: z.string(),
  decorationType: z.nativeEnum(FlowDecorationType),
  position: z.object({
    x: z.number(),
    y: z.number(),
  }),
  groupNodeId: z.string().optional(),
});
export type BaseFlowDecoration = z.infer<typeof BaseFlowDecorationSchema>;
